import React from 'react';
import { Fade } from 'react-awesome-reveal';
import { Container, VideoPlayer } from '../../../components';
import HomepageVideo from './HomepageVideo';

const Video = ({ entity, onAnswerPage }) => {
  const forHomepage = entity.getIn(['field_for_homepage', 0, 'value'], false);
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  if (forHomepage) {
    return <HomepageVideo entity={entity} />;
  }

  return (
    <Container id={paragraphKey} className="Paragraph">
      <div className={`${!onAnswerPage && 'row'}`}>
        <div className={`${!onAnswerPage && 'col-12 col-lg-8 offset-lg-2'}`}>
          <Fade triggerOnce bottom distance="50px" duration={500}>
            <div className="Video">
              <VideoPlayer
                title={entity.getIn(['field_video', 0, 'title'])}
                url={entity.getIn(['field_video', 0, 'embed'])}
              />
            </div>
          </Fade>
        </div>
      </div>
    </Container>
  );
};

export default Video;
